<template>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header card-gis-filter">
        <el-collapse v-model="activeName" @change="handleCollapse">
          <el-collapse-item :title="titleFilter" name="1">
            <div class="row p-3">
              <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3">
                <label>{{ $t('common_words.farm') }} *</label>
                <br />
                <el-select
                  @clear="clusterVsBoxReportForm.farms = []"
                  clearable
                  multiple
                  :multiple-limit="1"
                  v-bind:collapse-tags="true"
                  filterable
                  class="select-primary custom-width-select required-farm shadow-sm"
                  size="large"
                  v-model="clusterVsBoxReportForm.farms"
                  :placeholder="`${$t('common_words.select')}...`"
                >
                  <el-option
                    v-for="(option, index) in farms"
                    class="select-primary"
                    :value="option.id"
                    :label="option.name"
                    :key="index + option.id"
                  ></el-option>
                </el-select>
              </div>
              <div class="col-12 col-sm-12 col-md-2 col-lg-2">
                <label>{{ $t('common_words.analyze_by') }} </label>
                <br />
                <el-select
                  @change="changeByInterval"
                  filterable
                  @clear="clusterVsBoxReportForm.bySel = null"
                  clearable
                  class="select-primary custom-width-select required-bySel shadow-sm"
                  size="large"
                  v-model="clusterVsBoxReportForm.bySel"
                  :placeholder="`${$t('common_words.select')}...`"
                >
                  <el-option
                    v-for="option in optionsInterval"
                    class="select-primary"
                    :value="option.value"
                    :label="option.label"
                    :key="option.value"
                  ></el-option>
                </el-select>
              </div>
              <div
                class="col-12 col-sm-8 col-md-4 col-lg-4 col-xl-3"
                v-if="
                  clusterVsBoxReportForm.bySel &&
                  clusterVsBoxReportForm.bySel != 'week' &&
                  clusterVsBoxReportForm.bySel != 'year'
                "
              >
                <label>{{ $t('common_words.calendar') }}</label>
                <br />
                <el-date-picker
                  v-if="renderComponent"
                  v-model="rangeDate"
                  clearable
                  class="shadow-sm required-year"
                  v-bind:type="typedatepicket"
                  :picker-options="pickerOptions"
                  range-separator="-"
                  :placeholder="`${$t('common_words.select2')}...`"
                  :start-placeholder="$t('common_words.initial_date')"
                  :end-placeholder="$t('common_words.final_date')"
                >
                </el-date-picker>
              </div>
              <div
                class="col-6 col-sm-3 col-md-2 col-lg-2 col-xl-1"
                style="padding-right: 0; padding-top: 32px"
                v-if="
                  clusterVsBoxReportForm.bySel == 'week' ||
                  clusterVsBoxReportForm.bySel == 'year'
                "
              >
                <el-select
                  clearable
                  @clear="clusterVsBoxReportForm.week_sel_init = null"
                  filterable
                  class="select-primary custom-width-select required-year shadow-sm"
                  size="large"
                  v-model="clusterVsBoxReportForm.year_sel_init"
                >
                  <el-option
                    v-for="(option, index) in Object.keys(years).reverse()"
                    class="select-primary"
                    :value="option"
                    :label="option"
                    :key="index * 100 + 1"
                  ></el-option>
                </el-select>
              </div>
              <div
                class="col-6 col-sm-3 col-md-2 col-lg-2 col-xl-1"
                style="padding-top: 32px"
                v-if="
                  clusterVsBoxReportForm.bySel == 'week' &&
                  clusterVsBoxReportForm.year_sel_init
                "
              >
                <el-select
                  clearable
                  filterable
                  class="select-primary custom-width-select required-week shadow-sm"
                  size="large"
                  v-model="clusterVsBoxReportForm.week_sel_init"
                >
                  <el-option
                    v-for="(week, index) in years[
                      clusterVsBoxReportForm.year_sel_init
                    ]"
                    class="select-primary"
                    :value="week"
                    :label="week"
                    :key="index * 200 + 2"
                  ></el-option>
                </el-select>
              </div>
              <div
                class="col-6 col-sm-3 col-md-2 col-lg-2 col-xl-1"
                style="padding-right: 0; padding-top: 32px"
                v-if="
                  clusterVsBoxReportForm.bySel == 'week' ||
                  clusterVsBoxReportForm.bySel == 'year'
                "
              >
                <el-select
                  clearable
                  @clear="clusterVsBoxReportForm.week_sel_end = null"
                  filterable
                  class="select-primary custom-width-select required-year shadow-sm"
                  size="large"
                  v-model="clusterVsBoxReportForm.year_sel_end"
                >
                  <el-option
                    v-for="(option, index) in Object.keys(years).reverse()"
                    class="select-primary"
                    :value="option"
                    :label="option"
                    :key="index * 300 + 4"
                  ></el-option>
                </el-select>
              </div>
              <div
                class="col-6 col-sm-3 col-md-2 col-lg-2 col-xl-1"
                style="padding-top: 32px"
                v-if="
                  clusterVsBoxReportForm.bySel == 'week' &&
                  clusterVsBoxReportForm.year_sel_end
                "
              >
                <el-select
                  clearable
                  filterable
                  class="select-primary custom-width-select required-week shadow-sm"
                  size="large"
                  v-model="clusterVsBoxReportForm.week_sel_end"
                >
                  <el-option
                    v-for="(week, index) in years[
                      clusterVsBoxReportForm.year_sel_end
                    ]"
                    class="select-primary"
                    :value="week"
                    :label="week"
                    :key="index * 400 + 6"
                  ></el-option>
                </el-select>
              </div>
              <div class="col-12 col-md-4 col-xl-2">
                <label class="label-primary" style="color: transparent">{{
                  $t('common_words.filter')
                }}</label
                ><br />
                <l-button wide type="info" class="btn-filter" @click="validate">
                  {{ $t('common_words.filter') }}
                </l-button>
              </div>
            </div>
            <br />
          </el-collapse-item>
        </el-collapse>
      </card>
      <br />
      <template v-if="clusterVsBoxReport">
        <card class="custom-shadow-card-header">
          <div
            v-if="
              Object.keys(chartOptions1).length > 0 &&
              Object.values(chartOptions1.xAxis.categories).length
            "
          >
            <div class="row">
              <div class="col-12">
                <highcharts :options="chartOptions1"></highcharts>
              </div>
            </div>
          </div>
          <div v-else>
            <br />
            <h5 class="text-muted text-center">
              {{ $t('common_words.selected_record_no_graph') }}
            </h5>
          </div>
        </card>
        <br />
        <card class="custom-shadow-card-header">
          <div v-if="isIndex()">
            <div
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <el-select
                clearable
                @clear="pagination.perPage = 10"
                class="select-default mb-3 shadow-sm"
                style="width: 200px"
                v-model="pagination.perPage"
                :placeholder="$t('common_words.per_page')"
                filterable
              >
                <el-option
                  class="select-default"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                ></el-option>
              </el-select>
              <el-input
                clearable
                class="mb-3 shadow-sm"
                style="width: 200px"
                :placeholder="$t('common_words.search_records')"
                v-model="searchQuery"
                aria-controls="datatables"
              />
            </div>
            <div class="col-sm-12">
              <el-table
                stripe
                :default-sort="{ prop: 'name', order: 'descending' }"
                style="width: 100%"
                :data="queriedData"
                :border="true"
              >
                <el-table-column
                  v-for="column in tableColumns"
                  :key="column.label"
                  :min-width="column.minWidth"
                  :prop="column.prop"
                  :label="column.label"
                  :formatter="formatNumberTable"
                  :render-header="renderHeader"
                >
                </el-table-column>
              </el-table>
            </div>
          </div>
          <div v-else>
            <br />
            <h5 class="text-muted text-center">
              {{ $t('common_words.no_permissions') }}
            </h5>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <div class>
              <p class="card-category">
                {{ $t('table2.showing') }} {{ from + 1 }} {{ $t('table2.a') }}
                {{ to }} {{ $t('table2.of') }} {{ total }}
                {{ $t('table2.entries') }}
              </p>
            </div>
            <l-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="pagination.total"
              pageFirst="false"
              pageLast="false"
            ></l-pagination>
          </div>
        </card>
        <div class="row" style="padding-right: 13px; padding-left: 13px">
          <div class="col-6" v-if="isPDF()">
            <div class="text-right">
              <button
                class="btn btn-danger custom-shadow-btn"
                @click="exportPDF"
              >
                <em class="fa fa-file-pdf-o"></em>
                {{ $t('common_words.export_to_pdf') }}
              </button>
            </div>
          </div>
          <div class="col-6" v-if="isExcel()">
            <div class="text-left">
              <button
                class="btn custom-btn-success custom-shadow-btn"
                @click="exportExcel"
              >
                <em class="fa fa-file-excel-o"></em>
                {{ $t('common_words.export_to_excel') }}
              </button>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { Chart } from 'highcharts-vue';
import { MixinExport } from 'src/mixins/mixin-export';
import exportingInit from 'highcharts/modules/exporting';
import Formatter from 'src/class/Formatter';
import Highcharts from 'highcharts';
import mixinCharts from 'src/util/mixinCharts';
import MixinDatePicker from 'src/util/mixinDatePicker';
import mixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import moment from 'moment';
import SweetAlert from 'src/class/Alerts';
import i18n from 'src/i18n';

exportingInit(Highcharts);

export default {
  components: {
    highcharts: Chart,
  },

  computed: {
    optionsInterval() {
      return {
        0: { label: i18n.t('common_words.day'), value: 'daterange' },
        1: { label: i18n.t('common_words.week'), value: 'week' },
        2: { label: i18n.t('common_words.month'), value: 'monthrange' },
        3: { label: i18n.t('common_words.year'), value: 'year' },
      };
    },

    titleFilter() {
      if (this.valueCollapse) {
        return this.valueCollapse.length === 1
          ? this.$i18n.t('uti.mixinFilter.hideFilters')
          : this.$i18n.t('uti.mixinFilter.showFilters');
      }

      return this.$i18n.t('uti.mixinFilter.hideFilters');
    },
  },

  data() {
    return {
      clusterVsBoxReportForm: {
        bySel: null,
      },
      chartOptions1: {},
      activeName: '1',
      typedatepicket: 'daterange',
      valueCollapse: null,
      reports: [],
      interval: 'Semana',
      years: [],
      farms: [],
      clusterVsBoxReport: false,
      titleCard: '',
      tableColumns: null,
    };
  },

  mixins: [
    mixinMasters,
    MixinPermissions,
    MixinDatePicker,
    mixinCharts,
    MixinExport,
    MixinMenu,
  ],
  watch: {
    '$i18n.locale': 'forceRerender',
  },

  methods: {
    renderHeader(h, { column }) {
      return h('div', [
        h('span', column.label.split('-')[0]),
        h('br'),
        h('span', column.label.split('-')[1]),
      ]);
    },

    changeByInterval() {
      this.clusterVsBoxReport = false;
      for (
        let index = 0;
        index < Object.values(this.optionsInterval).length;
        index++
      ) {
        const element = Object.values(this.optionsInterval)[index];
        if (element.label == this.clusterVsBoxReportForm.bySel) {
          this.typedatepicket = element.value;
          break;
        }
      }
    },

    handleCollapse(val) {
      this.valueCollapse = val;
    },

    validate() {
      this.clusterVsBoxReportForm.calendar_sel = this.rangeDate;

      if (this.clusterVsBoxReportForm.bySel == null) {
        return this.validationInputsRequired('bySel');
      } else if (
        this.clusterVsBoxReportForm.farms == null ||
        this.clusterVsBoxReportForm.farms.length == 0
      ) {
        return this.validationInputsRequired('farm');
      } else if (
        (this.clusterVsBoxReportForm.bySel == 'year' &&
          (this.clusterVsBoxReportForm.year_sel_init == null ||
            this.clusterVsBoxReportForm.year_sel_end == null)) ||
        (this.clusterVsBoxReportForm.bySel == 'week' &&
          this.isYearSelRequired() &&
          this.clusterVsBoxReportForm.year_sel_init == null)
      ) {
        return this.validationInputsRequired('year');
      } else if (
        this.isWeekSekRequired() &&
        this.clusterVsBoxReportForm.week_sel_init == null &&
        this.clusterVsBoxReportForm.bySel == 'week'
      ) {
        return this.validationInputsRequired('week');
      } else if (
        this.isYearSelRequired() &&
        this.clusterVsBoxReportForm.year_sel_end == null &&
        this.clusterVsBoxReportForm.bySel == 'week'
      ) {
        return this.validationInputsRequired('year');
      } else if (
        this.isWeekSekRequired() &&
        this.clusterVsBoxReportForm.week_sel_end == null &&
        this.clusterVsBoxReportForm.bySel == 'week'
      ) {
        return this.validationInputsRequired('week');
      } else if (this.clusterVsBoxReportForm.calendar_sel == null) {
        SweetAlert.warning(i18n.t('common_words.no_associated_calendars'));
      } else {
        this.chartOptions1 = {};
        this.chartOptions2 = {};
        this.loadBoxReport();
      }
    },

    formatNumberTable(row, column) {
      return typeof row[column.property] === 'string' ||
        row[column.property] instanceof String
        ? row[column.property]
        : Formatter.formatMoney(row[column.property], 3);
    },

    loadData() {
      let data = {
        farms: this.clusterVsBoxReportForm.farms,
        init:
          parseInt(this.clusterVsBoxReportForm.year_sel_init) * 100 +
          parseInt(this.clusterVsBoxReportForm.week_sel_init),
        end:
          parseInt(this.clusterVsBoxReportForm.year_sel_end) * 100 +
          parseInt(this.clusterVsBoxReportForm.week_sel_end),
        bySel: this.clusterVsBoxReportForm.bySel,
      };

      switch (this.clusterVsBoxReportForm.bySel) {
        case 'year':
          data.init = parseInt(this.clusterVsBoxReportForm.year_sel_init);
          data.end = parseInt(this.clusterVsBoxReportForm.year_sel_end);
          break;
        case 'monthrange':
          data.init = parseInt(moment(this.rangeDate[0]).format('YYYYMM'));
          data.end = parseInt(moment(this.rangeDate[1]).format('YYYYMM'));
          break;
        case 'daterange':
          data.init = moment(this.rangeDate[0]).format('YYYY-MM-DD');
          data.end = moment(this.rangeDate[1]).format('YYYY-MM-DD');
          break;
      }

      return data;
    },

    loadBoxReport() {
      this.showHideLoading(true);
      let data = this.loadData();
      data.route = 'scales/clusters/vsreports';

      Axios.saveMaster(data)
        .then((response) => {
          if (response.data) {
            this.tableColumns = response.data.table_columns;
            this.tableData = response.data.table_data;
            this.searchFuse(
              this.tableColumns.map((prop) => {
                return prop.prop;
              })
            );
            this.chartOptions1 = this.columns(response.data.column_chart1);
            this.clusterVsBoxReport = true;
          }

          this.showHideLoading();
        })
        .catch((error) => {
          console.log(error);
          this.showHideLoading();
        });
    },

    isYearSelRequired() {
      return this.interval == 'Semana';
    },

    isWeekSekRequired() {
      return this.interval == 'Semana';
    },

    exportPDF() {
      let data = this.loadData();
      data.route = 'scales/clusters/reports/pdf';
      data.title = 'Informe Racimos VS Cajas';
      data.name_file = `${i18n.t('production.boxes_report')}.pdf`;

      this.PDF(data, 'POST', true)
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },

    exportExcel() {
      let data = this.loadData();
      data.route = 'scales/clusters/reports/excel';
      data.title = 'Informe Racimos VS Cajas';
      data.name_file = `${i18n.t('production.boxes_report')}.xlsx`;

      this.Excel(data, 'POST', true)
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },
  },

  created() {
    if (this.isIndex()) {
      this.showHideLoading(true);
      Axios.getMasters('farms/farms/onlyfruit')
        .then((response) => {
          Axios.getMasters('calendars/getyearsbusiness')
            .then((response1) => {
              this.farms = response.data.data;
              this.years = response1.data;
              this.showHideLoading();
            })
            .catch((error) => this.showMessageErrors(error));
        })
        .catch((error) => this.showMessageErrors(error));
    } else {
      this.showHideLoading();
    }

    let current = new Date();
    this.rangeDate = [
      new Date(current.setDate(current.getDate() - current.getDay())),
      new Date(current.setDate(current.getDate() - current.getDay() + 6)),
    ];
  },

  mounted() {
    this.selectedItemOnMenu('scales');
  },

  destroyed() {
    this.deselectedItemOnMenu('scales');
  },
};
</script>
<style></style>
